import { inject, Pipe, PipeTransform } from '@angular/core';
import { GenericStreamsService } from '../service/generic-streams.service';

@Pipe({
    name: 'getStreamnameByConfigId',
    standalone: false
})
export class GetStreamnameByConfigIdPipe implements PipeTransform {

    genService = inject(GenericStreamsService)

    transform(configId: string): string {
        const stream = this.genService.allStreams.find(stream => stream.id === configId);
        return stream ? stream.name : configId;
    }

}
